import { Outlet } from 'react-router-dom';
import ConsoleLayout from '@/components/layout/ConsoleLayout';
import { navSetting } from '@/components/layout/navigation/configNav';
import TabModeToggle from '@/components/ui/select-theme/tab-mode-toggle';

const SettingLayout = () => {
  const version = import.meta.env.VITE_VERSION_APP;
  return (
    <ConsoleLayout
      title="Setting"
      navbar={navSetting}
      navbarFooter={
        <div className="flex flex-col items-center gap-2">
          <TabModeToggle />
          <div className="p-2 pb-6 text-center font-semibold text-muted-foreground">
            version: {version}
          </div>
        </div>
      }
      isSidebar={false}
    >
      <div className="pt-10">
        <Outlet />
      </div>
    </ConsoleLayout>
  );
};

export default SettingLayout;
